export const DEBIT_CREDIT_NOTE_REPORT_REQUEST = 'DEBIT_CREDIT_NOTE_REPORT_REQUEST';
export const DEBIT_CREDIT_NOTE_REPORT_SUCCESS = 'DEBIT_CREDIT_NOTE_REPORT_SUCCESS';
export const DEBIT_CREDIT_NOTE_REPORT_FAILURE = 'DEBIT_CREDIT_NOTE_REPORT_FAILURE';